import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/collections-men";

export default class CollectionsMen extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("Men's Collections")} | ${this.ucfirst("window-title")}`
    );
  }
}
